var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyProfessionalGoals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2344 17.7936C24.835 17.7143 24.4224 17.6719 24 17.6719C20.5106 17.6719 17.6719 20.5106 17.6719 24C17.6719 27.4894 20.5106 30.3281 24 30.3281C27.4894 30.3281 30.3281 27.4894 30.3281 24C30.3281 23.5776 30.2857 23.165 30.2064 22.7656L26.486 26.486C25.8219 27.15 24.939 27.5156 24 27.5156C23.061 27.5156 22.1781 27.15 21.514 26.486C20.85 25.8219 20.4844 24.939 20.4844 24C20.4844 23.061 20.85 22.1781 21.514 21.514L25.2344 17.7936Z",
    fill: "url(#paint0_linear_31350_38005)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2101 15.7334L39.6888 18.2548C39.4364 18.5071 39.152 18.7165 38.845 18.8788C39.4004 20.485 39.7031 22.2077 39.7031 24C39.7031 32.6588 32.6588 39.7031 24 39.7031C15.3412 39.7031 8.29688 32.6588 8.29688 24C8.29688 15.3412 15.3412 8.29688 24 8.29688C25.7929 8.29688 27.5165 8.59991 29.123 9.15564C29.2856 8.84833 29.4935 8.56268 29.7455 8.31091L32.2666 5.78986C29.7455 4.64087 26.9465 4 24 4C12.9719 4 4 12.9719 4 24C4 35.0281 12.9719 44 24 44C35.0281 44 44 35.0281 44 24C44 21.0535 43.3591 18.2545 42.2101 15.7334Z",
    fill: "url(#paint1_linear_31350_38005)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9774 14.0507L28.7638 11.5189C27.2834 10.9516 25.6776 10.6406 24 10.6406C16.6337 10.6406 10.6406 16.6337 10.6406 24C10.6406 31.3663 16.6337 37.3594 24 37.3594C31.3663 37.3594 37.3594 31.3663 37.3594 24C37.3594 22.3224 37.0484 20.7166 36.4811 19.2362L33.9493 19.0226L32.0911 20.8805C32.4659 21.8491 32.6719 22.9008 32.6719 24C32.6719 28.7818 28.7818 32.6719 24 32.6719C19.2182 32.6719 15.3281 28.7818 15.3281 24C15.3281 19.2182 19.2182 15.3281 24 15.3281C25.0992 15.3281 26.1509 15.5341 27.1195 15.9089L28.9774 14.0507Z",
    fill: "url(#paint2_linear_31350_38005)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0633 10.8947L31.4045 14.9377L23.1714 23.1707C22.7137 23.6281 22.7137 24.3703 23.1714 24.8278C23.4 25.0567 23.7 25.1711 24 25.1711C24.3 25.1711 24.6 25.0567 24.8286 24.8278L33.0616 16.5948L37.1046 16.9356C37.1375 16.9384 37.1702 16.9399 37.2031 16.9399C37.5126 16.9399 37.811 16.8172 38.0317 16.5966L43.0033 11.6247C43.3259 11.3024 43.4321 10.8221 43.2755 10.3936C43.1187 9.96512 42.7277 9.66666 42.2733 9.62851L38.6741 9.32486L38.3707 5.72592C38.3323 5.27121 38.0338 4.88028 37.6057 4.72372C37.1772 4.56686 36.6968 4.67337 36.3743 4.99564L31.4026 9.96756C31.1585 10.2117 31.0343 10.5508 31.0633 10.8947Z",
    fill: "url(#paint3_linear_31350_38005)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31350_38005",
    x1: 17.6719,
    y1: 24,
    x2: 30.3281,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31350_38005",
    x1: 4,
    y1: 24,
    x2: 44,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31350_38005",
    x1: 10.6406,
    y1: 24,
    x2: 37.3594,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_31350_38005",
    x1: 22.8281,
    y1: 14.9117,
    x2: 43.3468,
    y2: 14.9117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfessionalGoals);
export default __webpack_public_path__ + "static/media/my-professional-goals.e64c0e817fec8e1e7eafc40eb20deba5.svg";
export { ForwardRef as ReactComponent };